import React, { useState } from 'react'
import FooterCon from './FooterCon'
import Wrapper from '../../helpers/Wrapper'
import logo from '../../assets/images/logo.png'
import { Link } from 'react-router-dom'
import Accordion from '../Accordion/Accordion'
import Input from '../Form Elements/Input'
import Button from '../../ui/Button'
import { useCategory } from '../../hooks/useCategory'
import { useMutation } from '@tanstack/react-query'
import { apiClient } from '../../helpers/Axios'
import toast from 'react-hot-toast'

function Footer() {

    const { data: categories } = useCategory()
    const [email, setEmail] = useState("")

    // Customer Service Links
    const customerServiceLinks = [
        {
            title: "Privacy Policy",
            href: '/pages/privacy-policy'
        },
        {
            title: "Term & Condition",
            href: '/pages/term-condition'
        },
        {
            title: "Track Your Order",
            href: '/order-tracking'
        },
        {
            title: "Shop Locations",
            href: '/pages/our-store'
        },
        {
            title: "Advanced Search",
            href: '/search'
        },
        {
            title: "FAQ'S",
            href: '/pages/faq'
        }
    ]

    // subscribe button =

    const { mutate, isPending } = useMutation({
        mutationFn: (payload) => {
            return apiClient.post('/contact/subscribe', payload)
        },
        onError: (e) => {
            toast.dismiss()
            toast.error(e?.response?.data || e?.message)
        },
        onSuccess: (data) => {
            toast.success(data?.data)
        }
    })

    const handleSubscribe = () => {
        mutate({ email })
    }

    return (
        <div className='w-full relative py-12'>
            <div className="">
                <Wrapper>
                    <hr className='mb-24' />

                    {/* Mobile  Footer*/}
                    <div className="lg:hidden w-full flex flex-col gap-y-4">
                        <div className='w-full'>
                            <img src={logo} alt="" className='w-36' />
                            <ul className='text-gray-500 mt-3 space-y-3'>
                                <li>Kente Mbli Street, 12</li>
                                <li>Accra - Ghana</li>
                                <li>
                                    <a href="tel:+233502835422">+233 50 283 5422</a>
                                </li>
                                <li>
                                    <a href="mailto:leatheroncallgh@gmail.com">Leatheroncallgh@gmail.com</a>
                                </li>
                            </ul>
                        </div>

                        <Accordion title={"Customer Services"}>
                            <ul className='flex flex-col gap-1.5 text-gray-500 w-full '>
                                {customerServiceLinks?.map((link, i) => (
                                    <li key={i}>
                                        <Link to={link?.href}>{link.title}</Link>
                                    </li>
                                ))}
                            </ul>
                        </Accordion>


                        <Accordion title={"Shop By Category"}>
                            {categories && categories?.length > 0 && (
                                <ul className='flex flex-col gap-1.5 text-gray-500 w-full '>
                                    {categories?.slice(0, 6)?.map((category, i) => (
                                        <li key={i} className='hover:translate-x-2 transition ease-in'>
                                            <Link to={`/product-category/${category?.name}`}>{category?.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </Accordion>


                        <Accordion title={"Sign Up to Newsletter"} >
                            <ul className='flex flex-col gap-1.5 text-gray-500 w-full '>
                                <li>
                                    Subscribe to our newsletter and get $5 off your first order!
                                </li>

                                <div className="flex flex-col gap-3 w-full mt-2">
                                    <div className="w-full">
                                        <Input placeholder="Your Email?" type='email' value={email} onChange={(e) => setEmail(e?.target?.value)} />
                                    </div>
                                    <div className="">
                                        <Button loading={isPending} onClick={handleSubscribe}>Subscribe</Button>
                                    </div>
                                </div>
                            </ul>
                        </Accordion>

                    </div>

                    {/* Desktop */}

                    <div className="lg:flex justify-between hidden w-full">
                        <div className='w-full'>
                            <img src={logo} alt="" className='w-36' />
                            <ul className='text-gray-500 mt-3 space-y-3'>
                                <li>Kpentenplebi Rd, Dzorwulu</li>
                                <li>Accra - Ghana</li>
                                <li>
                                    <a href="tel:+233502835422">+233 50 283 5422</a>
                                </li>
                                <li>
                                    <a href="mailto:leatheroncallgh@gmail.com">Leatheroncallgh@gmail.com</a>
                                </li>
                            </ul>
                        </div>
                        <FooterCon title={"Customer Services"}>
                            <ul className='space-y-4 text-gray-500 w-full'>
                                {customerServiceLinks?.map((link, i) => (
                                    <li key={i} className='hover:translate-x-2 transition ease-in'>
                                        <Link to={link?.href}>{link.title}</Link>
                                    </li>
                                ))}
                            </ul>
                        </FooterCon>

                        <FooterCon title={"Shop By Category"} >
                            {categories && categories?.length > 0 && (
                                <ul className='space-y-4 text-gray-500 w-full '>
                                    {categories?.slice(0, 6)?.map((category, i) => (
                                        <li key={i} className='hover:translate-x-2 transition ease-in'>
                                            <Link to={`/product-category/${category?.name}`}>{category?.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </FooterCon>

                        <FooterCon title={"Sign Up to Newsletter"} >
                            <ul className='flex flex-col gap-1.5 text-gray-500 w-full '>
                                <li>
                                    Subscribe to our newsletter and get $5 off your first order!
                                </li>

                                <div className="flex flex-col gap-3 w-full mt-2">
                                    <div className="w-full">
                                        <Input placeholder="Your Email?" type='email' value={email} onChange={(e) => setEmail(e?.target?.value)} />
                                    </div>
                                    <div className="">
                                        <Button loading={isPending} onClick={handleSubscribe}>Subscribe</Button>
                                    </div>
                                </div>
                            </ul>
                        </FooterCon>
                    </div>
                </Wrapper>
            </div>
        </div>
    )
}

export default Footer